export default __webpack_public_path__ + "static/1.7-Responsive-DO-7c936d899fa0929ca1a00aa6a1878144.png";